import { createRouter, createWebHistory } from 'vue-router';

const routes = [
    {
        path: '/',
        name: 'Dashboard',
        component: () => import('@/views/Dashboard')
    },
    {
        path: '/sign-in',
        name: 'SignIn',
        component: () => import('@/views/SignIn'),
        meta: { allowAnonymous: true, hideMenu: true }
    },
    {
        path: '/forgot-password',
        name: 'ForgotPassword',
        component: () => import('@/views/ForgotPassword'),
        meta: { allowAnonymous: true, hideMenu: true }
    },
    {
        path: '/reset-password',
        name: 'ResetPassword',
        component: () => import('@/views/ResetPassword'),
        meta: { allowAnonymous: true, hideMenu: true }
    },
    {
        path: '/invite',
        redirect: '/invite/begin',
        name: 'InviteClient',
        component: () => import('@/views/InviteClient'),
        children: [
            {
                path: '/invite/begin',
                name: 'InviteClientStepBegin',
                component: () => import('@/views/Invite/InviteStepBegin')
            },
            {
                path: '/invite/generate',
                name: 'InviteClientStepGenerate',
                component: () => import('@/views/Invite/InviteStepGenerate')
            },
            {
                path: '/invite/ready',
                name: 'InviteClientStepReady',
                component: () => import('@/views/Invite/InviteStepReady')
            }
        ]
    },
    {
        path: '/consultants',
        redirect: '/consultants/list',
        name: 'Consultants',
        component: () => import('@/views/PureRouterView'),
        children: [
            {
                path: '/consultants/list',
                name: 'ConsultantsList',
                component: () => import('@/views/ConsultantsList')
            },

            {
                path: '/consultants/invite',
                redirect: '/consultants/invite/begin',
                name: 'ConsultantInvite',
                component: () => import('@/views/InviteConsultant'),
                children: [
                    {
                        path: '/consultants/invite/begin',
                        name: 'InviteConsultantStepBegin',
                        component: () => import('@/views/ConsultantInvite/InviteStepBegin')
                    },
                    {
                        path: '/consultants/invite/generate',
                        name: 'InviteConsultantStepGenerate',
                        component: () => import('@/views/ConsultantInvite/InviteStepGenerate')
                    },
                    {
                        path: '/consultants/invite/ready',
                        name: 'InviteConsultantStepReady',
                        component: () => import('@/views/ConsultantInvite/InviteStepReady')
                    }
                ]
            }
        ]
    },
    {
        path: '/partnerTransactions',
        name: 'PartnerTransactions',
        component: () => import('@/views/PartnerTransactions')
    },
    {
        path: '/settings',
        name: 'MySettings',
        component: () => import('@/views/MySettings')
    },
    {
        path: '/partner/settings',
        name: 'PartnerSettings',
        component: () => import('@/views/PartnerSettings')
    },
    {
        path: '/sign-up',
        redirect: '/sign-up/setupuser',
        name: 'SignUp',
        component: () => import('@/views/SignUp'),
        meta: { allowAnonymous: true, hideMenu: true },
        children: [
            {
                path: '/sign-up/setupuser',
                name: 'SignUpStepOne',
                component: () => import('@/components/signUp/SignUpStepOne'),
                meta: { allowAnonymous: true, hideMenu: true }
            },
            {
                path: '/sign-up/setup2fa',
                name: 'SignUpStepTwo',
                component: () => import('@/components/signUp/SignUpStepTwo'),
                meta: { allowAnonymous: true, hideMenu: true }
            }
        ]
    },
    {
        path: '/reset-2fa',
        redirect: '/reset-2fa/setupuser',
        name: 'Reset2FA',
        component: () => import('@/views/Reset2FA'),
        meta: { allowAnonymous: true, hideMenu: true },
        children: [
            {
                path: '/reset-2fa/setupuser',
                name: 'reset2FAStepOne',
                component: () => import('@/components/reset2FA/Reset2FAStepOne'),
                meta: { allowAnonymous: true, hideMenu: true }
            },
            {
                path: '/reset-2fa/setup2fa',
                name: 'Reset2FAStepTwo',
                component: () => import('@/components/reset2FA/Reset2FAStepTwo'),
                meta: { allowAnonymous: true, hideMenu: true }
            }
        ]
    },
    {
        path: '/reset-2fa/expired',
        name: 'Reset2FAExpired',
        component: () => import('@/views/Reset2FAExpired'),
        meta: { allowAnonymous: true, hideMenu: true }
    },
    {
        path: '/apply',
        redirect: '/apply/welcome',
        name: 'Apply',
        component: () => import('@/views/Apply/Apply'),
        meta: { allowAnonymous: true, hideMenu: true },
        children: [
            {
                path: '/apply/welcome',
                name: 'ApplyStepOne',
                component: () => import('@/views/Apply/ApplyStepOne'),
                meta: { allowAnonymous: true, hideMenu: true }
            },
            {
                path: '/apply/firststep',
                name: 'ApplyStepTwo',
                component: () => import('@/views/Apply/ApplyStepTwo'),
                meta: { allowAnonymous: true, hideMenu: true }
            },
            {
                path: '/apply/secondstep',
                name: 'ApplyStepThree',
                component: () => import('@/views/Apply/ApplyStepThree'),
                meta: { allowAnonymous: true, hideMenu: true }
            },
            {
                path: '/apply/thirdstep',
                name: 'ApplyStepFour',
                component: () => import('@/views/Apply/ApplyStepFour'),
                meta: { allowAnonymous: true, hideMenu: true }
            },
            {
                path: '/apply/finalstep',
                name: 'ApplyStepFive',
                component: () => import('@/views/Apply/ApplyStepFive'),
                meta: { allowAnonymous: true, hideMenu: true }
            }
        ]
    },
    {
        path: '/admin/confirmapplication',
        name: 'ApplicationResponse',
        redirect: '/admin/confirmapplication/details',
        props: true,
        component: () => import('@/views/ApplicationResponse/ApplicationResponse'),
        children: [
            {
                path: '/admin/confirmapplication/details',
                name: 'ApplicationResponseStepOne',
                component: () => import('@/views/ApplicationResponse/ApplicationResponseStepOne'),
                props: true
            },
            {
                path: '/admin/confirmapplication/commission',
                name: 'ApplicationResponseStepTwo',
                component: () => import('@/views/ApplicationResponse/ApplicationResponseStepTwo'),
                props: true
            }
        ]
    },
    {
        path: '/admin',
        name: 'Partners',
        component: () => import('@/views/admin/partnerDashboard/PartnerDashboard.vue')
    },
    {
        path: '/admin/partners/:partnerId/users/:partnerName',
        name: 'PartnerUsers',
        component: () => import('@/views/admin/partnerDashboard/PartnerUsers.vue'),
        meta: {
            parentPage: 'Partners'
        }
    },
    {
        path: '/admin/invite',
        name: 'InvitePartner',
        component: () => import('@/views/InvitePartner.vue')
    },
    {
        path: '/admin/applications',
        name: 'Applications',
        component: () => import('@/views/PartnerApplications')
    },
    {
        path: '/admin/users',
        name: 'UsersList',
        component: () => import('@/views/UserList.vue')
    },
    {
        path: '/admin/users/add',
        name: 'AddUser',
        component: () => import('@/views/AddUser.vue')
    },
    {
        path: '/admin/transactions',
        name: 'Transactions',
        component: () => import('@/views/Transactions.vue')
    },
    {
        path: '/admin/commissions',
        name: 'Commissions',
        component: () => import('@/views/Commissions.vue')
    },
    {
        path: '/admin/managerelations',
        name: 'ManageRelations',
        component: () => import('@/views/admin/ManageRelations.vue')
    },
    {
        path: '/:catchAll(.*)*',
        name: 'NotFound',
        component: () => import('@/views/NotFound')
    }
];

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes
});

export default router;
